module.exports = __webpack_public_path__ + "static/media/guardar.3d174c8c.png";